import {
  CounterRegisterSession,
  RegisterationTable,
} from "@/types/pos/register";

import {
  SalesReportTable
} from '@/types/pos/sales-history'

import { apiSlice } from "@/redux/apiSlice";
interface RegisterQueryInput {
  query: string;
  counter_id?: number;
}
interface TransactionQueryInput {
  query: string;    }

export const Register = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getlastRegisterSession: builder.query<CounterRegisterSession, number>({
        query: (counter_id) => ({
          url: `/pos/counters/${counter_id}/last-session`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Register"],
      }),
      openRegister: builder.mutation<
        CounterRegisterSession,
        CounterRegisterSession
      >({
        query: (registerdata) => ({
          url: `/pos/counters/${registerdata.counter_id}/registers`,
          method: "POST",
          body: registerdata,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["Register"],
      }),
      closeRegister: builder.mutation<
        CounterRegisterSession,
        CounterRegisterSession
      >({
        query: (registerdata) => ({
          url: `/pos/registers/${registerdata.id}`,
          method: "PUT",
          body: registerdata,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["Register"],
      }),
      getAllRegisterSession: builder.query<
        RegisterationTable,
        RegisterQueryInput
      >({
        query: (searchCriteria) => ({
          url: `/pos/counters/${searchCriteria.counter_id}/registers${searchCriteria.query.length > 0 ? "?" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Register"],
      }),
      getAlltransaction: builder.query<
        SalesReportTable,
        TransactionQueryInput
      >({
        query: (searchCriteria) => ({
          url: `/pos/transactions${searchCriteria.query.length > 0 ? "?" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction"],
      }),
      getAllTransactionForExport: builder.query<
        SalesReportTable,
        TransactionQueryInput
      >({
        query: (searchCriteria) => ({
          url: `/pos/transactions?offset=0&sort_key=id&sort_order=desc${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Transaction"],
      }),
      getAllRegisterSessionForExport: builder.query<
        RegisterationTable,
        RegisterQueryInput
      >({
        query: (searchCriteria) => ({
          url: `/pos/counters/${searchCriteria.counter_id}/registers?offset=0&sort_key=id&sort_order=desc${searchCriteria.query.length > 0 ? "&" + searchCriteria.query : ""}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Register"],
      }),
    };
  },
});

export const {
  useCloseRegisterMutation,
  useOpenRegisterMutation,
  useGetlastRegisterSessionQuery,
  useGetAllRegisterSessionQuery,
  useGetAlltransactionQuery,
  useLazyGetAllTransactionForExportQuery,
  useLazyGetAllRegisterSessionForExportQuery,
} = Register;
